import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer
      style={{
        background: '#04050E',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        paddingTop: '80px',
        paddingBottom: '40px',
        position: 'relative',
        zIndex: 2,
      }}
    >
      <div className="ht-container">
        <div
          className="footer-grid-container"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            gap: '40px',
            marginBottom: '32px',
          }}
        >
          {/* Col 1: Brand & Official Registered Office */}
          <div style={{ gridColumn: 'span 4' }} className="footer-col brand-col">
            {/* Official Logo Branding */}
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', textDecoration: 'none', marginBottom: '20px' }}>
              <div
                style={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'rgba(255, 255, 255, 0.08)',
                  border: '1px solid rgba(0, 212, 255, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '6px',
                  boxShadow: '0 0 20px rgba(0, 212, 255, 0.25)',
                }}
              >
                <img
                  src="/assets/images/hungry-logo.svg"
                  alt="Hungry Top Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 0 6px rgba(0, 212, 255, 0.8))',
                  }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ color: '#FFFFFF', fontWeight: 800, fontSize: '1.1rem', letterSpacing: '-0.02em', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  HUNGRY TOP
                </span>
                <span style={{ color: '#00D4FF', fontWeight: 700, fontSize: '0.62rem', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
                  TECHNOLOGIES LIMITED
                </span>
              </div>
            </Link>

            {/* Registered Office Details */}
            <div
              style={{
                background: 'rgba(255, 255, 255, 0.03)',
                padding: '18px 20px',
                borderRadius: '18px',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                marginBottom: '20px',
              }}
            >
              <span style={{ fontSize: '0.75rem', fontWeight: 800, color: '#00D4FF', textTransform: 'uppercase', letterSpacing: '0.1em', display: 'block', marginBottom: '8px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                REGISTERED OFFICE
              </span>
              <p style={{ color: '#E2E8F0', fontSize: '0.88rem', lineHeight: 1.5, marginBottom: '12px', fontFamily: "'Inter', sans-serif" }}>
                <strong>HungryTop Technologies Limited</strong><br />
                BL-5, PH-II, Golf Green Urban Complex,<br />
                Kolkata - 700095, West Bengal, India
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.85rem' }}>
                <a href="tel:+919836809855" style={{ color: '#A78BFA', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}>
                  <i className="fas fa-phone-alt" style={{ fontSize: '0.8rem' }}></i>
                  <span>Tel: +91 9836809855</span>
                </a>
                <a href="mailto:info@hungrytop.com" style={{ color: '#00D4FF', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}>
                  <i className="fas fa-envelope" style={{ fontSize: '0.8rem' }}></i>
                  <span>Email: info@hungrytop.com</span>
                </a>
                <a href="https://www.hungrytop.com" target="_blank" rel="noopener noreferrer" style={{ color: '#A3A8B8', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <i className="fas fa-globe" style={{ fontSize: '0.8rem' }}></i>
                  <span>www.hungrytop.com</span>
                </a>
              </div>
            </div>

            {/* Playstore Download Badge */}
            <a
              href="https://play.google.com/store/apps/details?id=com.hungrytop"
              target="_blank"
              rel="noopener noreferrer"
              className="glass-card"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                padding: '12px 20px',
                borderRadius: '16px',
                textDecoration: 'none',
                border: '1px solid rgba(0, 212, 255, 0.4)',
                background: 'rgba(0, 212, 255, 0.08)',
                transition: 'all 0.3s ease',
              }}
            >
              <i className="fab fa-google-play" style={{ fontSize: '1.6rem', color: '#00D4FF' }}></i>
              <div>
                <span style={{ fontSize: '0.65rem', color: '#A3A8B8', textTransform: 'uppercase', display: 'block', lineHeight: 1, fontWeight: 700 }}>
                  GET IT ON
                </span>
                <span style={{ fontSize: '0.98rem', fontWeight: 800, color: '#FFF', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Google Play
                </span>
              </div>
            </a>
          </div>

          {/* Wrapper for Auto-Adjusting Nav Columns (4 Columns Grid on Desktop) */}
          <div
            style={{
              gridColumn: 'span 8',
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '32px',
            }}
            className="footer-nav-columns-wrapper"
          >
            {/* Col 2: Services */}
            <div className="footer-col nav-col">
              <h4 style={{ color: '#FFF', fontSize: '0.95rem', fontWeight: 800, marginBottom: '18px', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                Services
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {['Custom Software', 'Mobile Apps', 'Web Development', 'AI & Machine Learning', 'Cloud Solutions', 'FinTech Solutions'].map((item, i) => (
                  <Link key={i} to="/services" style={{ color: '#CBD5E1', fontSize: '0.9rem', textDecoration: 'none', transition: 'color 0.2s ease', fontWeight: 600, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                    {item}
                  </Link>
                ))}
              </div>
            </div>

            {/* Col 3: Products */}
            <div className="footer-col nav-col">
              <h4 style={{ color: '#FFF', fontSize: '0.95rem', fontWeight: 800, marginBottom: '18px', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                Products
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Link to="/products" style={{ color: '#818CF8', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 700, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  PaperLoan (Lending)
                </Link>
                <Link to="/products" style={{ color: '#38BDF8', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 700, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  HungryTop (Commerce)
                </Link>
                <Link to="/team" style={{ color: '#CBD5E1', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 600, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Leadership Team
                </Link>
                <Link to="/technologies" style={{ color: '#CBD5E1', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 600, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Tech Stack
                </Link>
              </div>
            </div>

            {/* Col 4: Official Pages */}
            <div className="footer-col nav-col">
              <h4 style={{ color: '#FFF', fontSize: '0.95rem', fontWeight: 800, marginBottom: '18px', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                Company & Legal
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Link to="/terms-and-conditions" style={{ color: '#CBD5E1', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 600, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Terms & Conditions
                </Link>
                <Link to="/privacy-policy" style={{ color: '#CBD5E1', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 600, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Privacy Policy
                </Link>
                <Link to="/help" style={{ color: '#CBD5E1', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 600, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Help Center
                </Link>
                <Link to="/sellertnc" style={{ color: '#CBD5E1', fontSize: '0.9rem', textDecoration: 'none', fontWeight: 600, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  Seller T&C
                </Link>
              </div>
            </div>

            {/* Col 5: Newsletter */}
            <div className="footer-col newsletter-col">
              <h4 style={{ color: '#FFF', fontSize: '0.95rem', fontWeight: 800, marginBottom: '18px', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                Stay Updated
              </h4>
              <p style={{ color: '#A3A8B8', fontSize: '0.84rem', marginBottom: '16px', lineHeight: 1.5 }}>
                Subscribe for enterprise AI & software updates.
              </p>

              {subscribed ? (
                <span style={{ color: '#10B981', fontSize: '0.85rem', fontWeight: 700 }}>✓ Subscribed successfully!</span>
              ) : (
                <form onSubmit={handleSubscribe} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <input
                    type="email"
                    required
                    placeholder="Work email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      padding: '10px 14px',
                      borderRadius: '10px',
                      background: 'rgba(255, 255, 255, 0.05)',
                      border: '1px solid rgba(255, 255, 255, 0.15)',
                      color: '#FFFFFF',
                      fontSize: '0.82rem',
                      outline: 'none',
                      fontFamily: "'Inter', sans-serif",
                    }}
                  />
                  <button
                    type="submit"
                    className="btn-primary-gradient"
                    style={{
                      padding: '10px',
                      borderRadius: '10px',
                      fontSize: '0.82rem',
                      minHeight: '40px',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    Subscribe
                  </button>
                </form>
              )}
            </div>
          </div>

        </div>

        {/* Bottom Bar: Copyright & Operational Status */}
        <div
          style={{
            paddingTop: '32px',
            borderTop: '1px solid rgba(255, 255, 255, 0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
            color: '#64748B',
            fontSize: '0.84rem',
          }}
          className="footer-bottom-bar"
        >
          <div>
            © {new Date().getFullYear()} <strong>HungryTop Technologies Limited</strong>. Recognized as the Best Software Company in Kolkata, West Bengal, India. All rights reserved.
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#10B981', boxShadow: '0 0 10px #10B981' }}></span>
            <span style={{ color: '#A3A8B8', fontWeight: 600 }}>All Systems Operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


